const CANVAS_WIDTH = 38;
const CANVAS_HEIGHT = 46;
const TIP_Y = 43;

const WHITE = "#FFFFFF";

const pinSvg = (color, borderColor) => {
  const innerFill = color.toLowerCase() === WHITE.toLowerCase() ? borderColor : WHITE;

  return `
<svg xmlns="http://www.w3.org/2000/svg" width="${CANVAS_WIDTH}" height="${CANVAS_HEIGHT}" viewBox="0 0 ${CANVAS_WIDTH} ${CANVAS_HEIGHT}">
  <defs>
    <filter id="pin-shadow" x="-40%" y="-20%" width="180%" height="160%">
      <feDropShadow dx="0" dy="1.5" stdDeviation="1.4" flood-color="#2b1a08" flood-opacity="0.35" />
    </filter>
  </defs>
  <path
    filter="url(#pin-shadow)"
    fill="${color}"
    stroke="${borderColor}"
    stroke-width="1.2"
    d="M19 2C10.66 2 4 8.77 4 17.24 4 28.5 19 ${TIP_Y} 19 ${TIP_Y}s15-14.5 15-25.76C34 8.77 27.34 2 19 2z"
  />
  <circle cx="19" cy="17.5" r="6" fill="${innerFill}" />
</svg>
`;
};

export const buildPinIcon = (color, { scale = 0.7, borderColor = "#8a5518" } = {}) => {
  const maps = window.google?.maps;
  if (!maps) return undefined;

  const width = CANVAS_WIDTH * scale;
  const height = CANVAS_HEIGHT * scale;

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
      pinSvg(color, borderColor)
    )}`,
    scaledSize: new maps.Size(width, height),
    anchor: new maps.Point(width / 2, height * (TIP_Y / CANVAS_HEIGHT)),
  };
};
